module.exports = __webpack_public_path__ + "static/media/xrp.efe535fb.svg";